import React from 'react';

const PlusIcon = (props) => {
  let fill = props.fill ? props.fill : '#000';
  let fillOpacity = props.fill ? 1 : 0.38;
  return (
    <svg width="66" height="67" viewBox="0 0 66 67" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="31.2168" y="16.5594" width="3.46853" height="34.6853" fill={fill} />
      <rect
        x="50.2937"
        y="32.1678"
        width="3.46853"
        height="34.6853"
        transform="rotate(90 50.2937 32.1678)"
        fill={fill}
      />
    </svg>
  );
};

export default PlusIcon;
